import { useController } from 'react-hook-form';
import { Input } from 'antd';
import InputLabel from '@mui/material/InputLabel';
import { makeStyles } from '@mui/styles';
import { clsx } from 'clsx';

interface Props {
  source: string;
  label?: string | false;
  placeholder?: string;
  className?: string;
  styled?: boolean;
  autoFocus?: boolean;
  itemRef?: any;
  maxLength?: number;
  disabled?: boolean;
  onBlur?: (e: any) => void;
}

export const TextAreaInput = ({
  source, label, placeholder, className, styled, autoFocus, itemRef, maxLength, disabled, onBlur,
}: Props) => {
  const {
    field: { value = '', onChange = () => {} },
  } = useController({ name: source });
  const cls = useStyles();

  const handleChange = (e: any) => {
    onChange(e.target.value);
  };

  return (
    <>
      {label && <InputLabel className={clsx(styled && cls.styledLabel)}>{label}</InputLabel>}
      <Input.TextArea
        ref={itemRef}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        className={clsx(className, styled && cls.styledTextArea)}
        autoFocus={autoFocus}
        maxLength={maxLength}
        disabled={disabled}
        onBlur={onBlur}
      />
    </>
  );
};

const useStyles = makeStyles({
  styledLabel: {
    color: 'var(--primary-color)',
    fontFamily: 'var(--font-primary)',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 1,
    paddingBottom: 12,
  },
  styledTextArea: {
    borderRadius: 8,
    border: '1px solid var(--primary-color)',

    '> div::before': {
      display: 'none',
    },
    '& input': {
      borderRadius: 8,
      border: '1px solid var(--primary-color)',
      height: 90,
      padding: '6px 12px',
    },
  },
});
